import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const AdagioBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["adagio"],
    },
    params: {
      type: "object",
      properties: {
        organizationId: createSchemaByBasicTypes("number", null, {
          additionalProperties: false,
        }),
        site: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        placement: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        adUnitElementId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      adUnitName: createSchemaByBasicTypes("string", null, {
        additionalProperties: false,
      }),
      required: [
        "adUnitName",
        "organizationId",
        "site",
        "placement",
        "adUnitElementId",
      ],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
